import { render, staticRenderFns } from "./MyServiceItem.vue?vue&type=template&id=18d6752a&scoped=true&"
import script from "./MyServiceItem.vue?vue&type=script&lang=ts&"
export * from "./MyServiceItem.vue?vue&type=script&lang=ts&"
import style0 from "./MyServiceItem.vue?vue&type=style&index=0&id=18d6752a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d6752a",
  null
  
)

export default component.exports